import React from "react";
import { Create, translate } from "react-admin";
import GroupForm from "./GroupForm";

const GroupTitle = ({ translate }) => {
  return <span>{`สร้าง${translate("group.group")}`}</span>;
};
const Title = translate(GroupTitle);

export const GroupCreate = props => (
  <Create title={<Title />} {...props}>
    <GroupForm />
  </Create>
);



// WEBPACK FOOTER //
// ./src/components/group/GroupCreate.js